import { render } from "./carregamento.vue?vue&type=template&id=f78175d0"
import script from "./carregamento.vue?vue&type=script&lang=js"
export * from "./carregamento.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__